// material ui
import { alpha, ButtonProps, Theme } from '@mui/material';

export const buttonCustomization = () => ({
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: '6px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: '5px 16px',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
      },
    },
    variants: [
      {
        props: {
          variant: 'contained',
          color: 'primary',
        } as Partial<ButtonProps>,
        style: ({ theme }: { theme: Theme }) => ({
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: 0,
          cursor: 'pointer',
          padding: '5px 16px',
          fontSize: '14px',
          lineHeight: '20px',
          verticalAlign: 'middle',
          border:
            theme.palette.mode === 'dark'
              ? '1px solid #6e7681'
              : '1px solid #1b1f2326',
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[50]
              : theme.palette.grey[900],
          backgroundColor:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[700]
              : theme.palette.grey[0],
          borderColor: theme.palette.mode === 'dark' ? '#30363d' : '#1b1f2326',
          boxShadow:
            theme.palette.mode === 'dark'
              ? 'rgba(1, 4, 9, 0.35) 0px 1px 0px 0px, rgba(255, 255, 255, 0.06) 0px 1px 0px 0px inset'
              : 'rgba(27, 31, 35, 0.04) 0px 1px 0px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px 0px inset',
          transition: '0.2s cubic-bezier(0.3, 0, 0.5, 1)',
          transitionProperty: 'color, background-color, border-color',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[700]
                : theme.palette.grey[100],
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[600]
                : theme.palette.grey[300],
            color:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[50]
                : theme.palette.grey[900],
            transitionDuration: '0.1s',
          },
          '&.Mui-disabled': {
            color:
              theme.palette.mode === 'dark'
                ? alpha('#f0f6fc', 0.7)
                : alpha('#24292e', 0.55),
            borderColor:
              theme.palette.mode === 'dark'
                ? alpha('#6e7681', 0.35)
                : alpha('#1b1f2326', 0.34),
            backgroundColor:
              theme.palette.mode === 'dark'
                ? alpha('#57606a', 0.45)
                : alpha('#eaeef2', 0.55),
            boxShadow: 'none',
          },
        }),
      },
      {
        props: {
          variant: 'outlined',
          color: 'primary',
        } as Partial<ButtonProps>,
        style: ({ theme }: { theme: Theme }) => ({
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: 0,
          cursor: 'pointer',
          padding: '5px 16px',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          verticalAlign: 'middle',
          border:
            theme.palette.mode === 'dark'
              ? '1px solid #30363d'
              : '1px solid #1b1f2326',
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[200]
              : theme.palette.grey[700],
          backgroundColor:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[900]
              : theme.palette.grey[50],
          borderColor:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[700]
              : theme.palette.grey[200],
          boxShadow:
            theme.palette.mode === 'dark'
              ? 'rgba(1, 4, 9, 0.3) 0px 1px 0px 0px, rgba(255, 255, 255, 0.03) 0px 1px 0px 0px inset'
              : 'rgba(27, 31, 35, 0.04) 0px 1px 0px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px 0px inset',
          transition: '0.2s cubic-bezier(0.3, 0, 0.5, 1)',
          transitionProperty: 'color, background-color, border-color',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[800]
                : theme.palette.grey[100],
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[600]
                : theme.palette.grey[300],
            color: theme.palette.mode === 'dark' ? '#c9d1d9' : '#24292e',
            transitionDuration: '0.1s',
          },
          '&.Mui-focusVisible': {
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 0 0 3px ${alpha('#2f81f7', 0.35)}`
                : `0 0 0 3px ${alpha('#0969da', 0.25)}`,
          },
          '&.Mui-disabled': {
            color:
              theme.palette.mode === 'dark'
                ? alpha('#c9d1d9', 0.45)
                : alpha('#24292e', 0.55),
            borderColor:
              theme.palette.mode === 'dark'
                ? alpha('#30363d', 0.6)
                : alpha('#1b1f2326', 0.2),
            backgroundColor:
              theme.palette.mode === 'dark'
                ? alpha('#21262d', 0.7)
                : alpha('#fafbfc', 0.75),
            boxShadow: 'none',
          },
        }),
      },
    ],
  },
});
